module.exports = __webpack_public_path__ + "static/media/close-icon-white.97f8b2e3.svg";